import { useLingui } from "@lingui/react";
import { StarIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface StarButtonProps {
  starred: boolean;
  onToggle: () => void;
  /** The metric's label, so each star names what it pins. */
  metricLabel: string;
  className?: string;
}

/** Pins a metric to My metrics, or removes it (#2175 B2). */
export function StarButton({ starred, onToggle, metricLabel, className }: StarButtonProps) {
  const { i18n } = useLingui();
  const label = starred
    ? i18n._({ id: "analytics.metrics.unstar", message: "Remove {metric} from My metrics", values: { metric: metricLabel } })
    : i18n._({ id: "analytics.metrics.star", message: "Add {metric} to My metrics", values: { metric: metricLabel } });
  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className={cn("size-8", className)}
      aria-pressed={starred}
      aria-label={label}
      title={label}
      onClick={onToggle}
    >
      <StarIcon
        aria-hidden="true"
        className={cn("size-4", starred ? "fill-current text-warning-on-surface" : "text-muted-foreground")}
      />
    </Button>
  );
}
